import { useAsyncCallback } from '../../../hooks'
import { EntityAsyncMultiValuedListMoreItems } from '../../Entity'
import { MultiValuedList } from '../../MultiValuedList'
import {
  getDataItems,
  phaseFilterByName,
  RequestPhaseAsyncMultiValuedListMoreItem,
} from '../../Request'
import { TextMultiValuedListItem } from '../../TextMultiValuedList'
import { getIdwellToIdwellRequestPhase } from '../IdwellToIdwell.api'

function IdwellToIdwellRequestPhaseAsyncMultiValuedList({
  Item = TextMultiValuedListItem,
  MoreItem = RequestPhaseAsyncMultiValuedListMoreItem,
  MoreItems = EntityAsyncMultiValuedListMoreItems,
  filter = phaseFilterByName,
  id,
  outboundUuid,
  ...restProps
}) {
  const handleLoadData = useAsyncCallback(() => {
    return getIdwellToIdwellRequestPhase(id, outboundUuid)
  }, [id, outboundUuid])

  return (
    <MultiValuedList
      {...restProps}
      Item={Item}
      MoreItem={MoreItem}
      MoreItems={MoreItems}
      filter={filter}
      moreItemsProps={{
        getData: handleLoadData,
        getDataItems,
      }}
    />
  )
}

export default IdwellToIdwellRequestPhaseAsyncMultiValuedList
